import React from 'react';
import { BaseDateTimeField, type BaseDateTimeFieldProps } from './BaseDateTimeField';

export type DateInputProps = BaseDateTimeFieldProps;

/**
 * Shared date-only field (VIS-136). Typed entry is the primary input; a native
 * picker is available as a secondary affordance. Value contract matches
 * <input type="date">: 'YYYY-MM-DD' or ''.
 */
export const DateInput: React.FC<DateInputProps> = (props) => (
  <BaseDateTimeField mode="date" {...props} />
);
